<template>
  <div v-if="blast.reviewsGiven.length">
    <p>{{ blast.reviewsGiven.length }} reviews you've given to others:</p>
    <peer-reviews :reviews="blast.reviewsGiven" display="given" />
  </div>
  <div v-else>
    You have not given any peer reviews yet.
  </div>
</template>

<script>

  export default {
    name: 'BlastReviewsGiven',
    props: {
      blast: {
        type: Object,
        required: true
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/_global/blast-reviews-given.vue